if (!customElements.get('dbtfy-form-validator')) {
  customElements.define(
    'dbtfy-form-validator',
    class DbtfyFormValidator extends HTMLElement {
      constructor() {
        super();

        this.formValidated = true;

        this.form = this.querySelector('form');
        this.form.setAttribute('novalidate', '');

        this.form.addEventListener('submit', this.validateForm.bind(this));

        this.form.querySelector("button[type='submit']").addEventListener('click', this.validateForm.bind(this));

        this.requiredFields = this.form.querySelectorAll('.field__input:required, .field__select:required');

        this.checkboxRequired = this.form.querySelectorAll('.checkbox__input');

        this.emailField = this.form.querySelectorAll('input[type="email"]');
        this.errorMessageBox = this.form.querySelector('.form__error-message');

        this.designMode = Shopify.designMode;

        this.init();
      }

      init() {
        if (this.designMode) {
          if (this.emailField.length == 0) {
            this.errorMessageBox.classList.remove('hidden');
            this.errorMessageBox.querySelector('.error').textContent = this.dataset.oneEmailError;
            return;
          }
          if (this.emailField.length > 1) {
            this.errorMessageBox.classList.remove('hidden');
            this.errorMessageBox.querySelector('.error').textContent = this.dataset.emailError;
            return;
          }
        }
      }

      validateForm(event) {
        event.preventDefault();
        event.stopPropagation();

        this.formValidated = true;

        this.checkRequiredFields();

        this.checkEmailField();
        this.checkboxInputField();

        if (this.formValidated) {
          if (this.dataset.afterSubmission) {
            this.checkAfterSubmission();
          }

          this.form.removeEventListener('submit', this.validateForm);
          this.form.submit();
          this.form.addEventListener('submit', this.validateForm.bind(this));
        }
      }

      checkAfterSubmission() {
        if (this.dataset.getMessage == 'customer') {
          const noteInput = this.querySelector('input[name="contact[note]"]');
          if (noteInput) {
            let bodyMessage = '';
            const fields = this.form.querySelectorAll('input:not([type="hidden"]), textarea, select');
            const data = {};

            fields.forEach((field) => {
              const type = field.type;
              const isCheckable = type === 'checkbox' || type === 'radio';

              if (isCheckable && !field.checked) {
                return;
              }

              let label = '';
              const container =
                field.closest('.field') || field.closest('.checkbox_field') || field.closest('.field-other');
              if (container) {
                const labelElement = container.querySelector('label.field__label') || container.querySelector('label');
                const pLabel =
                  container.querySelector('p') ||
                  (container.previousElementSibling && container.previousElementSibling.tagName === 'P'
                    ? container.previousElementSibling
                    : null);

                if (isCheckable && pLabel) {
                  label = pLabel.textContent.trim();
                } else if (labelElement) {
                  label = labelElement.textContent.trim();
                }
              }

              if (!label && field.tagName === 'SELECT') {
                const firstOption = field.options[0];
                if (firstOption && !firstOption.value) {
                  label = firstOption.textContent.trim().replace(/^Select\s+/i, '');
                }
              }

              if (!label) {
                label = field.placeholder || field.name;
                label = label.replace(/^contact\[(.*)\]$/, '$1').replace(/[_-]/g, ' ');
              }

              label = label.replace(/\s*\*\s*$/, '');

              const value = field.value.trim();

              if (value) {
                if (data[label]) {
                  data[label] += `, ${value}`;
                } else {
                  data[label] = value;
                }
              }
            });

            for (const [label, value] of Object.entries(data)) {
              bodyMessage += `${label}: ${value}\n`;
            }

            noteInput.value = bodyMessage;
          }
        }
      }

      checkRequiredFields() {
        this.requiredFields.forEach((field) => {
          if (!field.value) {
            field.closest('.field').classList.add('is-invalid');
            this.formValidated = false;
          } else {
            field.closest('.field').classList.remove('is-invalid');
          }
        });
      }

      checkboxInputField() {
        const field = this.querySelector('.checkbox_field');
        if (!field) return;

        const required = field.classList.contains('required');
        if (required) {
          const checkedCount = this.querySelectorAll('.checkbox_field input:checked').length;
          if (checkedCount == 0) {
            this.formValidated = false;
            this.querySelector('.checkbox_field').classList.add('is-invalid');
          } else {
            this.querySelector('.checkbox_field').classList.remove('is-invalid');
          }
        }
      }

      checkEmailField() {
        if (
          this.emailField[0] &&
          (this.emailField[0].validity.typeMismatch || this.emailField[0].validity.valueMissing)
        ) {
          this.emailField[0].closest('.field').classList.add('is-invalid');
          this.formValidated = false;
        } else {
          this.emailField[0].closest('.field').classList.remove('is-invalid');
        }
      }
    }
  );
}
